import React, { useMemo } from "react";
import intl from "react-intl-universal";
import ReactResizeDetector from "react-resize-detector";

import { ISelectOption, ISize } from "types";
import { ITeam } from "apis";

import {
  FIELD,
  TEAM_OPTIONS,
  STAT_HOME_TEAM_SIDE,
  STAT_POSSESSION_OPTIONS,
  STAT_RESULT_OPTIONS,
} from "../constants";

import { DetailsPanel } from "./DetailsPanel";
import { EditorGrid } from "./EditorGrid";
import { RadioField } from "./DetailsPanel/RadioField";
import { ActionPositionField } from "./ActionPositionField";

interface IMemoOptions {
  teams: ISelectOption[];
  homeTeamSide: ISelectOption[];
  possession: ISelectOption[];
  result: ISelectOption[];
}

interface IEditorProps {
  homeTeam?: ITeam;
  awayTeam?: ITeam;
}

const calculateHeight = (width: number) => {
  return (width * 9) / 16;
};

export const Editor = ({ homeTeam, awayTeam }: IEditorProps) => {
  const options = useMemo<IMemoOptions>(
    () => ({
      teams: TEAM_OPTIONS.map((option) => ({
        label: intl.get(option.i18nTag),
        value: option.value,
      })),
      homeTeamSide: STAT_HOME_TEAM_SIDE.map((option) => ({
        label: intl.get(option.i18nTag),
        value: option.value,
      })),
      possession: STAT_POSSESSION_OPTIONS.map((option) => ({
        label: intl.get(option.i18nTag),
        value: option.value,
      })),
      result: STAT_RESULT_OPTIONS.map((option) => ({
        label: intl.get(option.i18nTag),
        value: option.value,
      })),
    }),
    []
  );

  return (
    <EditorGrid container spacing={1}>
      <RadioField
        label={intl.get("STAT_FORM_LABEL_TEAM")}
        fieldName={FIELD.teamType}
        options={options.teams}
      />
      <DetailsPanel homeTeam={homeTeam} awayTeam={awayTeam} />
      <EditorGrid item xs={12}>
        <ReactResizeDetector handleWidth>
          {({ width }: ISize) => {
            const height = calculateHeight(width) || 0;
            return <ActionPositionField width={width} height={height} />;
          }}
        </ReactResizeDetector>
      </EditorGrid>
      <RadioField
        label={intl.get("STAT_FORM_LABEL_RESULT")}
        fieldName={FIELD.succeed}
        options={options.result}
      />
      <RadioField
        label={intl.get("STAT_FORM_LABEL_POSSESSION")}
        fieldName={FIELD.possession}
        options={options.possession}
      />
      <RadioField
        label={intl.get("STAT_FORM_LABEL_HOME_TEAM_SIDE")}
        fieldName={FIELD.homeTeamSide}
        options={options.homeTeamSide}
      />
    </EditorGrid>
  );
};
